import { Col, Divider, Row, Skeleton, Typography } from "antd";
import { ColumnSpacer } from "../common/ColumnSpacer";
import { FavoriteButton } from "../FavoriteButton";
import { GeoButton } from "../GeoButton";
import { IconText } from "../IconText";
import { Logo } from "../Category/Logo";
import { OfficeTypeTag } from "views/components/OfficeTypeTag";
import { Spacer } from "views/components/common/Spacer";
import { StatusLabel } from "../common/StatusLabel";
import { pathOr } from "ramda";
import React from "react";
import logos from "views/resources/logos/SVG";
import styled from "styled-components";
import { useGlobal } from "reactn";
export const OfficeInformation = ({ office = {}, user }) => {
	const { id, name, category_id, street, phone } = office;

	const [config] = useGlobal("UIConfig");

	const { hideOfficeFooter } = config;

	const hoursMessage = (office) =>
		pathOr(null, ["options", "hours_message"], office);

	const logo = pathOr(false, ["options", "brand", "logo"], office);
	const showLogo = pathOr(false, ["options", "brand", "show_logo"], office);
	const distance = pathOr(0, ["distance"], office);
	const kmDistance =
		office &&
		distance &&
		!isNaN(distance.distance) &&
		distance.distance / 1000;

	const distanceExists = distance && distance.distance !== Infinity;
	const stringDistance = distanceExists
		? Math.floor(distance.distance) < 1000
			? `${distance.distance.toFixed(0)} ${distance.unit}`
			: `${kmDistance.toFixed(1)} ${distance.unit}`
		: "";

	const offLatitude = pathOr(false, ["lat"], office);
	const offLongitude = pathOr(false, ["lng"], office);
	const userLat = pathOr(false, ["position", "lat"], user);
	const userLng = pathOr(false, ["position", "lon"], user);
	const isOfficeOpen = pathOr(false, ["online"], office);
	const showGeoButton =
		offLatitude && offLongitude && userLat && userLng ? true : false;

	return (
		<>
			<Content>
				<Row justify="center" align="middle" gutter={[0, 40]}>
					<Col>
						<Logo
							size={100}
							src={
								showLogo
									? logo
									: logos[`logo_${office.category_id}_color`]
							}
						></Logo>
					</Col>
					<Spacer rows={0.5} />
				</Row>

				<Row>
					<Col>
						<Typography.Title level={5}>{name}</Typography.Title>
					</Col>
				</Row>
				<Spacer rows={0.3} />
				{/* <Row>
					<Col>
						<p>{`a ${0} mts de distancia`}</p>
					</Col>
				</Row> */}

				<Row justify="start">
					{!office ? <Skeleton /> : <OfficeTypeTag office={office} />}
					<Spacer rows={0.5} />
					<StatusWrapper>
						{/* 	<span>
							{isOfficeOpen ? (
								<StatusLabel
									color={"green"}
									label={"Abierto"}
								/>
							) : (
								<StatusLabel color={"red"} label={"Cerrado"} />
							)}
						</span> */}
						{stringDistance && <span>·</span>}
						<span>{stringDistance}</span>
					</StatusWrapper>
					{!hideOfficeFooter && (
						<>
							<Divider />
							<div style={{ width: "100%" }}>
								<ButtonsContainer>
									<GeoButton
										offLatitude={offLatitude}
										offLongitude={offLongitude}
										userLat={userLat}
										userLng={userLng}
										desktop
										disabled={showGeoButton}
										borderless
									/>

									<ColumnSpacer column={1} />
									<FavoriteButton
										desktop
										officeId={id}
										borderless
									/>
									{/* <ButtonMakeFavorite
										desktop={true}
										officeId={id}
									></ButtonMakeFavorite> */}
								</ButtonsContainer>
							</div>
							<Divider />
						</>
					)}
				</Row>
			</Content>
			<ContentOfficeMetaData>
				<Row>
					<Col>
						<IconText value={street} iconType="location"></IconText>
					</Col>
				</Row>
				<Row>
					<Col>
						<IconText
							value={hoursMessage(office)}
							iconType="calendar"
						></IconText>
					</Col>
				</Row>
				<Row>
					<Col>
						<IconText value={phone} iconType="phone"></IconText>
					</Col>
				</Row>
			</ContentOfficeMetaData>
		</>
	);
};

const StatusWrapper = styled.div`
	display: flex;

	span {
		margin-left: 5px;
	}
`;
const Content = styled.div`
	width: 100%;
	.distance__span {
		font-weight: 300;
		font-size: 12px;
	}
`;

const ButtonsContainer = styled.div`
	display: flex;
`;

// const Content = styled.div`
// 	.ant-row {
// 		margin: 6px;
// 	}
// `;

const ContentOfficeMetaData = styled.div`
	margin-top: 24px;
`;
